module.exports = __webpack_public_path__ + "img/time-plan.0f9c22a3.svg";